import React from 'react';

import PropTypes from 'prop-types';

import { APP_STORE_LINK, APP_STORE } from './constants';

import styles from './storeButton.module.scss';

const AppStoreButton = ({ language, ...props }) => (
  <a
    alt="Hotmart - App Store"
    href={APP_STORE_LINK}
    rel="noopener noreferrer"
    target="_blank"
    className={styles.button}
    {...props}
  >
    <img src={APP_STORE[language] || APP_STORE.EN} alt="App Store" />
  </a>
);

AppStoreButton.propTypes = {
  language: PropTypes.string.isRequired
};

export default AppStoreButton;
